import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettingsHostComponent } from './app-settings-host/app-settings-host.component';
import { RouterModule } from '@angular/router';
import { CalculationModelViewComponent } from './components/calculation-model/calculation-model-view/calculation-model-view.component';
import { CalculationModelEditComponent } from './components/calculation-model/calculation-model-edit/calculation-model-edit.component';
import { CalculationModelRegisterComponent } from './components/calculation-model/calculation-model-register/calculation-model-register.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CalculationModelSearchAreaComponent } from './components/calculation-model/calculation-model-search-area/calculation-model-search-area.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from '../../components/common/app-common.module';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { TranslateModule } from '@ngx-translate/core';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { LayoutModule, PanelBarModule } from "@progress/kendo-angular-layout";
import { RaciTemplateViewComponent } from './components/raci-templates/raci-template-view/raci-template-view.component';
import { RaciTemplateSearchAreaComponent } from './components/raci-templates/raci-template-search-area/raci-template-search-area.component';
import { RaciTemplateNewComponent } from './components/raci-templates/raci-template-new/raci-template-new.component';
import { RaciTemplateEditComponent } from './components/raci-templates/raci-template-edit/raci-template-edit.component';
import { RaciTemplateFormComponent } from './components/raci-templates/raci-template-form/raci-template-form.component';
import { NavigationModule } from '../../navigation/navigation.module';
import { LocalizationHostComponent } from './localization-host/localization-host.component';
import { LocalizationGridComponent } from './components/localization-grid/localization-grid.component';
import { LocalizationFormHostComponent } from './components/localization/localization-form-host/localization-form-host.component';
import { LocalizationFormListComponent } from './components/localization/components/localization-form-list/localization-form-list.component';
import { LocalizationFormPreviewComponent } from './components/localization/components/localization-form-preview/localization-form-preview.component';
import { LocalizationWidgetComponent } from './components/localization-widget/localization-widget.component';
import { LocalizationWidgetHostDirective } from './components/localization-widget/localization-widget-host.directive';
import { LocalizationGridFormComponent } from './components/localization/components/localization-grid-form/localization-grid-form.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { AdminBusinessUnitComponent } from './components/admin-business-unit/admin-business-unit.component';
import { AdminRolesManagementComponent } from './components/admin-roles-management/admin-roles-management.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { RefListTranslateDialogComponent } from './components/localization/components/ref-list-translate-dialog/ref-list-translate-dialog.component';
import { AdminUserManagementComponent } from './components/admin-user-management/admin-user-management.component';
import { AdminUserManagementAsaSearchDialogComponent } from './components/admin-user-management-asa-search-dialog/admin-user-management-asa-search-dialog.component';

/**
 * The routes
 */
export const routerModule = RouterModule.forChild([{
  path: '',
  component: AppSettingsHostComponent
}]);

/**
 * Settings module
 */
@NgModule({
    imports: [
        CommonModule,
        routerModule,
        GridModule,
        TranslateModule,
        DropDownsModule,
        DateInputsModule,
        InputsModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        ButtonsModule,
        UploadsModule,
        LayoutModule,
        NavigationModule,
        PanelBarModule,
        DialogModule
    ],
    declarations: [
        AppSettingsHostComponent,
        CalculationModelViewComponent,
        CalculationModelEditComponent,
        CalculationModelRegisterComponent,
        CalculationModelSearchAreaComponent,
        /*CalculationModelAssignComponent,*/ //MOVED TO ProjectValuationModule, source still under app-setting folder for git history
        RaciTemplateViewComponent,
        RaciTemplateSearchAreaComponent,
        RaciTemplateNewComponent,
        RaciTemplateEditComponent,
        RaciTemplateFormComponent,
        LocalizationHostComponent,
        LocalizationGridComponent,
        LocalizationFormHostComponent,
        LocalizationFormListComponent,
        LocalizationFormPreviewComponent,
        LocalizationWidgetComponent,
        LocalizationWidgetHostDirective,
        LocalizationGridFormComponent,
        AdminBusinessUnitComponent,
        AdminRolesManagementComponent,
        RefListTranslateDialogComponent,
        AdminUserManagementComponent,
        AdminUserManagementAsaSearchDialogComponent
    ],
    exports: []
})
export class AppSettingsModule { }
